import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '@bya/auth/services/authentication.service';
import { EditarDatosPersonalesService } from '../service/editar-datos-personales.service';
import { MatDialog } from '@angular/material/dialog';
import { LoadingComponent } from 'app/common/loading/loading.component';
import { AlertDialogComponent } from 'app/common/alert-dialog/alert-dialog.component';
import { TerceroRegistroModalComponent } from 'app/main/datos-basicos/modules/tercero-registro/tercero-registro-modal/tercero-registro-modal.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
	selector: 'app-index',
	templateUrl: './index.component.html',
	styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

	public production:boolean;
	public logued:boolean = false;
	public avisos:string[] = new Array<string>();

	constructor
	(
		private http: HttpClient, 
		private _authService:AuthService,
		private editarDatosPersonalesService: EditarDatosPersonalesService,
		private _matDialog:MatDialog,
		private _matSnackbar:MatSnackBar
	) { }

	ngOnInit() {
		this.production = environment.production;
		this.logued = this._authService.isAuthenticated() == "true";
		if(this.logued){
			//this.ObtenerAvisos();
			this.getDatosUsuario();
		}
	}

	private getDatosUsuario(){
		if(this._authService.name?.toLowerCase() == 'admin') return;
		const loading = this._matDialog.open(LoadingComponent).addPanelClass('loading');
		this.editarDatosPersonalesService.GetTercero()
		.subscribe(response => {
			loading.close();
			if(!response) return;
			if(response.tipoPersona != 'Natural') return;
			if(response.fechaNacimiento) return;
			this._matDialog.open(AlertDialogComponent,{
				panelClass: 'alert',
				data: {
					mensaje : `Estimado ${response.nombreCompleto}, por políticas internas de la entidad le pedimos actualizar sus datos.`
				}
			})
			.afterClosed()
			.subscribe(() => {
				this._matDialog.open(TerceroRegistroModalComponent,{
					panelClass: 'tercero-registro-form-dialog',
					disableClose: true,
					data: {
						action: 'editar',
						terceroId: response.id,
						puedeCerrarModal: false
					}
				})
				.afterClosed()
				.subscribe(result => {
					if(!result) return;
					this._matSnackbar.open(result.mensaje, 'Entendido', {duration: 4500});
				})
			})
		})
	}

	public ObtenerAvisos(){
		this.avisos.push('La <span class="">Secretaría de Hacienda</span> se encuentra en proceso de cierre fiscal y contable de la vigencia 2020.'+
							'Las cuentas podrán ser elaboradas por el supervisor pero serán recibidas y revisadas al terminar este proceso.');
	}

	throwError() {
		throw new Error('My Pretty Error- Error contratación');
	}

	throwHttpError() {
		this.http.get('urlhere-contratacion').subscribe();
	}
}
